import { makeAutoObservable } from "mobx";
import { getConstByStandard } from "../../EmissionView/utils/getConstFileByStandard";
import { emissionActivityService } from "../../EmissionView/services/emissionViewService";
import { getEASchemaByStandard } from "../../EmissionView/modals/utils/getEASchemaByStandard";
import handleAPIError, {
  MESSAGE_CODES,
  showSuccessToast,
  showErrorToast,
} from "../../services/toast";
import {
  EMISSION_REMOVAL_MITIGATION_ENABLED,
  EMISSION_REMOVAL_MITIGATION_LABEL,
  RM_WORKFLOW_VIEWS,
  getEnabledEmissionCategoryOptions,
} from "../../EmissionView/utils/emissionRemovalMitigation";

import { boundarySettingService } from "../../BoundarySettings/services/boundarySettingService";
import {
  calendarPeriod,
  toReportingPeriod,
} from "../../EmissionView/utils/reportingPeriod";

import commonStore from "./commonStore";
import { companiesForYear } from "../../OrganizationalStructure/utils/company-operating-status";

const service = emissionActivityService;

class EmissionViewStore {
  ////////選擇哪個category
  selectedScope = null;

  ////////選擇Emission哪個頁面
  selectedView = "Year";

  ////////選擇哪一個Tab
  selectedTab = "1.1 Stationary Combustion";

  ////////pagination功能
  data = [];
  pageNow = 1;
  pageSize = 10;

  ////////選擇年份
  selectedYear = null;

  ////////顯示Emission Activity Modal
  showEmissionActivityModal = false;

  ////////顯示哪一個Emission Activity Modal;
  selectedEmissionActivityModal = "";

  ////////表單初始值
  emissionActivityFormDataDefault = {};

  /////data entry
  //data entry add modal 是否要開啟
  showDataEntryAddModal = false;

  //data entry edit modal 是否要開啟
  showDataEntryEditModal = false;

  //data entry set unit modal 是否要開啟
  showDataEntrySetUnitModal = false;

  //data entry delete modal 是否要開啟
  showDataEntryDeleteModal = false;

  //data entry upload files modal 是否要開啟
  showDataEntryUploadFilesModal = false;

  //data entry previre modal 是否要開啟
  showDataEntryPreviewModal = false;

  //data entry unit mismatch modal 是否要開啟
  isShowDataEntryUnitMismatchModal = false;

  //emission factor edit modal 是否要開啟
  showEmissionFactorEditModal = false;

  ////////Emission Factor 拿到表單的選項
  emissionFactorFormData = { quantificationMethod: "0" };

  ////////EFIncert FormData
  EFIncertFormData = {};

  ////////Emission Activity Modal loading頁面
  emissionActivityModalLoading = false;

  ////////Emission Activity List loading頁面
  emissionActivityListLoading = false;

  rmActivityListLoading = false;

  rmActivityEditData = null;

  ////////判斷是不是修改排放活動
  isEditEmissionActivity = false;

  ////////修改排放活動所需要的ID
  editId = "";

  ////////新增，取得單位下拉式選單，修改單位或時間，hints所需要的ID
  selectedDataEntry = null;

  ////////修改，刪除數據輸入，上傳佐證所需要的ID
  selectedDataEntryItem = null;

  ////////紀錄預覽佐證資料的資料
  selectedValidationFile = {
    link: "",
    fileName: "",
    extension: "",
  };

  ////////確認刪除排放活動所需要的物件
  confirmDeleteEmissionActivityData = {
    id: "",
    itemName: "",
    isShowModal: false,
  };

  ////////紀錄Emission的變數unit和gwp
  selectedEmissionGwpId = 3;
  selectedEmissionUnitId = "";

  //////// Emission loading畫面
  emissionListLoading = false;

  ////////EmissionViewContainer Company Name
  currentCompanyName = "";

  ////////EmissionViewContainer cId
  currentCId = "";

  ////////authComArr
  selectedAuthComArr = [];

  get inventoryCompanyList() {
    return companiesForYear(commonStore.companyList || [], this.selectedYear, commonStore.scopeType);
  }

  get authComArr() {
    if (commonStore.scopeType !== "COMPANY" || !this.selectedYear) return this.selectedAuthComArr;
    const allowed = new Set(this.inventoryCompanyList.map(c => String(c.id)));
    return this.selectedAuthComArr.filter(id => allowed.has(String(id)));
  }

  set authComArr(ids) {
    this.selectedAuthComArr = ids;
  }

  ////////是否要顯示選擇公司的下拉式選單
  ifShowCompanyDropdown = false;

  ////////Emission Activity list data
  emissionActivityListData = {
    fullList: [],
    page: 1,
    pageSize: 10,
  };

  ////////Emission Removal & Mitigation list data
  rmActivityListData = {
    fullList: [],
    page: 1,
    pageSize: 10,
  };

  ////////Emission Factor List data
  emissionFactorListData = {
    fullList: [],
    page: 1,
    pageSize: 10,
  };

  ////////1.4 完整 Emission Factor List 的自定義 EF 數量
  customEFCount = null;
  customEFCountStatus = "idle";
  customEFCountRequestId = 0;

  ////////DataEntry List data
  dataEntryListData = {
    fullList: [],
    page: 1,
    pageSize: 10,
  };
  dataEntryListLoading = false;
  dataEntryListError = null;

  ///////dataEntry的佐證資料
  validationFileListData = {};

  ///////Emission List data
  emissionListData = {
    fullList: [],
    page: 1,
    pageSize: 10,
  };

  ////////EmissionActivityExcelModal
  isShowEmissionActivityExcelModal = false;

  ////////dataEntryExcelModal
  isShowDataEntryExcelModal = false;

  ////////Refresh button
  isRefresh = false;

  ////////keyword(Search用)
  searchKeyword = "";

  ////////emissionFactorExcelModal
  isShowEmissionFactorExcelModal = false;

  ////////
  searchLabel = "";

  ////////是否要顯示EFIncertModal
  isShowEFIncertModal = false;

  ////////emissionActiviytList唯一識別碼
  activityListUniqueId = 0;

  /////////dataEntryList唯一識別碼
  dataEntryListUniqueId = 0;

  ////////emissionFactorList唯一識別碼
  emissionFactorListUniqueId = 0;

  //////////emissionList唯一識別碼
  emissionListUniqueId = 0;

  ////////新的排放活動以及排放係數合併頁面的排放活動資料

  EAFormData = {};

  ////////4.3第二個EAFormData
  landEAFormData = {};

  ////////新的排放活動以及排放係數合併頁面的排放係數資料
  EFFormData = {};

  ////////3.1 3.2排放活動以及排放係數合併頁面的排放活動資料 (陸)
  EFLandFormData = {};

  EFSeaFormData = {};

  EFAirFormData = {};

  ////////儲存如果驗證EF修改為不可行
  EFCheckId = "";

  //////// 4_3運輸 跳提示
  landEFCheckId = false;

  ////////是否顯示EF新增自定義表單
  showAddCustomEFModal = false;

  // 新增：計數器 & 計時器
  _eaBusy = 0;
  _eaShownAt = 0;
  _eaShowTimer = null;
  _eaHideTimer = null;

  // 參數：自己微調
  loadingShowDelay = 150; // 太快完成就不顯示
  loadingMinVisible = 400; // 一旦顯示至少亮這麼久
  loadingHideDelay = 150; // 關閉前再緩一下，避免 1→0→1 閃爍

  ////////DataEntryAddAndSetUnitModal
  isShowDataEntryAddAndSetUnitModal = false;

  //////// 現在的版本 14064 或是 GHG
  standardId = 1;

  constructor() {
    makeAutoObservable(this);
  }

  _handleSetSelectedScope = (label) => {
    const CONST = getConstByStandard(this.standardId);
    const enabledCategoryOptions = getEnabledEmissionCategoryOptions(
      CONST.categoryDropdown,
    );
    const nextLabel =
      !EMISSION_REMOVAL_MITIGATION_ENABLED &&
      label === EMISSION_REMOVAL_MITIGATION_LABEL
        ? enabledCategoryOptions[0]?.value ??
          enabledCategoryOptions[0]?.label
        : label;
    if (!nextLabel) return;

    const scopeChanged = this.selectedScope !== nextLabel;
    this.selectedScope = nextLabel;
    if (scopeChanged) this._handleSetSharedListPage(1);
    console.log(JSON.stringify(this.selectedScope));

    ////////當選擇category 後會預先選擇第一個Tab
    const tabTitle = CONST.categoryDropdown.find(
      (objects) =>
        objects.label === nextLabel || objects.value === nextLabel,
    );

    if (!tabTitle?.category?.length) return;

    ////////預期會是像1.1 Stationary Combustion
    this.selectedTab = tabTitle.category[0].label;
    console.log(JSON.stringify(this.selectedTab));

    if (
      nextLabel === EMISSION_REMOVAL_MITIGATION_LABEL &&
      !["Year", "Entity", ...RM_WORKFLOW_VIEWS].includes(this.selectedView)
    ) {
      this.selectedView = "Emission Activity";
    }

    if (
      nextLabel !== EMISSION_REMOVAL_MITIGATION_LABEL &&
      ["Emission Reduction", "Summary"].includes(this.selectedView)
    ) {
      this.selectedView = "Emission Activity";
    }
  };

  _handleSetSelectedView = (value) => {
    this.selectedView = value;
  };

  _handleSetSelectedTab = (label) => {
    const tabChanged = this.selectedTab !== label;
    this.selectedTab = label;
    if (tabChanged) this._handleSetSharedListPage(1);
    console.log(JSON.stringify(this.selectedTab));
  };

  ////////pagination
  _handleSetData = (data) => {
    if (Array.isArray(data)) {
      this.data = data;
    } else {
      console.error("提供的資料不是陣列");
    }
  };

  _handleSetPageNow = (pageNow) => {
    this.pageNow = pageNow;
  };

  // 計算資料總頁數
  get totalPages() {
    return Math.ceil(this.data.length / this.pageSize);
  }

  // 計算當前頁的資料範圍
  get currentPageData() {
    const start = (this.pageNow - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.data.slice(start, end);
  }

  ////////選擇年份
  _handleSetSelectedYear = (year) => {
    const yearChanged = this.selectedYear !== year;
    this.selectedYear = year;
    if (yearChanged) {
      this._handleSetSharedListPage(1);
      this.customEFCountRequestId += 1;
      this.customEFCount = null;
      this.customEFCountStatus = "idle";
    }
  };

  //////// 報告期間（取自組織邊界設定，供數據輸入的時間選擇器使用）
  reportingPeriod = null;

  fetchReportingPeriod = async (rootId, userId) => {
    const year = this.selectedYear;
    this.reportingPeriod = null;
    if (!year) return;

    let period;
    try {
      const res = await boundarySettingService.fetchBoundarySettingContent(
        rootId,
        userId,
        1,
        year,
      );
      period = toReportingPeriod(
        res.data?.baseStartDate,
        res.data?.baseEndDate,
        year,
      );
    } catch (error) {
      console.error("Error fetching reporting period", error);
      period = calendarPeriod(year);
    }
    // 回應返回前使用者可能已切換年份，避免舊年份的期間覆蓋新年份
    if (this.selectedYear === year) {
      this.reportingPeriod = period;
    }
  };

  ////////要不要渲染EmissionActivityModal
  _handleShowEmissionActivityModal = (label) => {
    this.rmActivityEditData = null;
    this.showEmissionActivityModal = true;
    this.selectedEmissionActivityModal = label;
  };

  _handleShowRMActivityEditModal = (activity) => {
    if (!activity?.id || !activity?.editInfo) return;

    this.rmActivityEditData = activity;
    this.showEmissionActivityModal = true;
    this.selectedEmissionActivityModal = EMISSION_REMOVAL_MITIGATION_LABEL;
  };

  ////////關閉modal
  _handleSetCloseEmissionActivityModal = () => {
    this.showEmissionActivityModal = false;
    this.isEditEmissionActivity = false;
    this.selectedEmissionActivityModal = "";
    this.rmActivityEditData = null;

    console.log("ouo");
  };

  ////////data entry
  ////////要不要渲染DataEntryAddModal
  _handleDataEntryAddModal = () => {
    this.showDataEntryAddModal = true;
  };
  ////////關閉modal
  _handleCloseDataEntryAddModal = () => {
    this.showDataEntryAddModal = false;
  };

  ////////要不要渲染DataEntryEditModal
  _handleDataEntryEditModal = () => {
    this.showDataEntryEditModal = true;
  };
  ////////關閉modal
  _handleCloseDataEntryEditModal = () => {
    this.showDataEntryEditModal = false;
  };

  ////////要不要渲染DataEntrySetUnitModal
  _handleDataEntrySetUnitModal = () => {
    this.showDataEntrySetUnitModal = true;
  };
  ////////關閉modal
  _handleCloseDataEntrySetUnitModal = () => {
    this.showDataEntrySetUnitModal = false;
  };

  ////////要不要渲染DataEntryDeleteModal
  _handleDataEntryDeleteModal = () => {
    this.showDataEntryDeleteModal = true;
  };
  ////////關閉modal
  _handleCloseDataEntryDeleteModal = () => {
    this.showDataEntryDeleteModal = false;
  };

  ////////要不要渲染DataEntryUploadFilesModal
  _handleDataEntryUploadFilesModal = () => {
    this.showDataEntryUploadFilesModal = true;
  };
  ////////關閉modal
  _handleCloseDataEntryUploadFilesModal = () => {
    this.showDataEntryUploadFilesModal = false;
  };

  ////////要不要渲染DataEntryPreviewModal
  _handleDataEntryPreviewModal = () => {
    this.showDataEntryPreviewModal = true;
  };
  ////////關閉modal
  _handleCloseDataEntryPreviewModal = () => {
    this.showDataEntryPreviewModal = false;
  };

  _handleSetIsShowDataEntryUnitMismatchModal = (value) => {
    this.isShowDataEntryUnitMismatchModal = value;
  };

  _handleSetIsShowDataEntryAddAndSetUnitModal = (value) => {
    this.isShowDataEntryAddAndSetUnitModal = value;
  };

  ////////要不要渲染EmissionFactorEditModal
  _handleEmissionFactorEditModal = () => {
    this.showEmissionFactorEditModal = true;
  };
  ////////關閉modal
  _handleCloseEmissionFactorEditModal = () => {
    this.showEmissionFactorEditModal = false;
    this.emissionFactorFormData = { quantificationMethod: "0" };
  };

  ////////更新Emission Factor 拿到表單的物件
  _handleSetEmissionFactorFormData = (data) => {
    this.emissionFactorFormData = {
      ...this.emissionFactorFormData,
      ...data,
    };
    console.log(JSON.stringify(this.emissionFactorFormData));
  };

  ////////設定EmissionActivityModal Loading 狀態
  ////以counter來決定完成的API數量
  _handleSetEmissionActivityModalLoading = (value) => {
    if (value === true) this._incBusy();
    if (value === false) this._decBusy();
  };

  _incBusy() {
    this._eaBusy += 1;

    // 有要顯示就取消關閉計時
    clearTimeout(this._eaHideTimer);

    // 尚未顯示 → 排程延遲顯示（避免超快請求閃一下）
    if (!this.emissionActivityModalLoading && !this._eaShowTimer) {
      this._eaShowTimer = setTimeout(() => {
        this._eaShowTimer = null;
        this._showNow();
      }, 0);
    }
  }

  _decBusy() {
    this._eaBusy = Math.max(0, this._eaBusy - 1);

    // 若已無忙碌 → 決定何時關閉（至少顯示到 minVisible，再加一點 hideDelay）
    if (this._eaBusy === 0) {
      // 若還在排程顯示，但已經沒事了 → 直接取消，不要再顯示
      clearTimeout(this._eaShowTimer);
      this._eaShowTimer = null;

      if (this.emissionActivityModalLoading) {
        const elapsed = Date.now() - (this._eaShownAt || 0);
        const wait = Math.max(
          this.loadingMinVisible - elapsed,
          this.loadingHideDelay,
          0,
        );
        clearTimeout(this._eaHideTimer);
        this._eaHideTimer = setTimeout(() => {
          this._eaHideTimer = null;
          this._hideNow();
        }, wait);
      }
    }
  }

  _showNow() {
    this._eaShownAt = Date.now();
    this.emissionActivityModalLoading = true;
  }

  _hideNow() {
    this.emissionActivityModalLoading = false;
  }

  ////////設定EmissionActivityList Loading狀態
  _handleSetEmissionActivityListLoading = (value) => {
    this.emissionActivityListLoading = value;
  };

  _handleSetRMActivityListLoading = (value) => {
    this.rmActivityListLoading = value;
  };

  ////////設定isEditEmissionActivity狀態
  _handleSetIsEditEmissionActivity = (value) => {
    this.isEditEmissionActivity = value;
  };

  ////////設定editId
  _handleSetEditId = (id) => {
    this.editId = id;
  };

  ////////顯示確認刪除排放活動的modal
  _handleSetConfirmDeleteEmissionActivityModal = (
    id,
    itemName,
    value,
    isFrozen,
  ) => {
    this.confirmDeleteEmissionActivityData.id = id;
    this.confirmDeleteEmissionActivityData.itemName = itemName;
    this.confirmDeleteEmissionActivityData.isShowModal = value;
    this.confirmDeleteEmissionActivityData.isFrozen = isFrozen;
    console.log(JSON.stringify(this.confirmDeleteEmissionActivityData));
  };

  ////////設定DataEntryList Loading狀態
  _handleSetDataEntryListLoading = (value) => {
    this.dataEntryListLoading = value;
  };

  ////////設定ValidationFileList Loading狀態
  _handleSetValidationFileListLoading = (value) => {
    this.validationFileListLoading = value;
  };

  ////////設定新增，取得單位下拉式選單，修改單位或時間，hints所需要的ID
  _handleSetSelectedDataEntry = (data) => {
    this.selectedDataEntry = data;
    console.log("this.selectedDataEntry", this.selectedDataEntry);
  };

  ///////設定修改，刪除數據輸入，上傳佐證所需要的ID
  _handleSetSelectedDataEntryItem = (dataItem) => {
    this.selectedDataEntryItem = dataItem;
  };

  ////////設定給DataEntryPreviewInfo
  _handleSetDataEntryPreviewInfo = (path, fileName, extension) => {
    this.selectedValidationFile.path = path;
    this.selectedValidationFile.fileName = fileName;
    this.selectedValidationFile.extension = extension;
  };

  ////////設定給EmissionInfo
  _handleSetEmissionInfo = (gwpId, unitId) => {
    const filterChanged =
      this.selectedEmissionGwpId !== gwpId ||
      this.selectedEmissionUnitId !== unitId;
    this.selectedEmissionUnitId = unitId;
    this.selectedEmissionGwpId = gwpId;
    if (filterChanged) this._handleSetSharedListPage(1);
  };

  ////////設定EmissionList Loading狀態
  _handleSetEmissionListLoading = (value) => {
    this.emissionListLoading = value;
  };

  ////////設定EmissionViewContainer Company Name
  _handleSetCurrentCompanyName = (name) => {
    this.currentCompanyName = name;
  };

  ////////設定EmissionViewContainer cId
  _handleSetCurrentCId = (cId) => {
    const companyChanged = this.currentCId !== cId;
    this.currentCId = cId;
    if (companyChanged) this._handleSetSharedListPage(1);
  };

  ////////切換顯示選擇公司的下拉式選單
  _handleToggleCompanyDropdown = () => {
    this.ifShowCompanyDropdown = !this.ifShowCompanyDropdown;
  };

  ////////設定emissionActivityListData
  _handleSetEmissionActivityListData = (key, data) => {
    this.emissionActivityListData[key] = data;
    console.log(JSON.stringify(this.emissionActivityListData));
  };

  _handleSetSharedListPage = (page) => {
    this.emissionActivityListData.page = page;
    this.rmActivityListData.page = page;
    this.emissionFactorListData.page = page;
    this.dataEntryListData.page = page;
    this.emissionListData.page = page;
  };

  _handleSetSharedListPageSize = (pageSize) => {
    this.emissionActivityListData.pageSize = pageSize;
    this.rmActivityListData.pageSize = pageSize;
    this.emissionFactorListData.pageSize = pageSize;
    this.dataEntryListData.pageSize = pageSize;
    this.emissionListData.pageSize = pageSize;
    this._handleSetSharedListPage(1);
  };

  _ensureSharedListPageInRange = (listData) => {
    const fullList = Array.isArray(listData?.fullList)
      ? listData.fullList
      : [];
    const totalPages = Math.ceil(fullList.length / listData.pageSize);
    if (listData.page > Math.max(totalPages, 1)) {
      this._handleSetSharedListPage(1);
    }
  };

  ////////計算emissionActivityList的目前頁面資料
  get EACurrentPageList() {
    const { fullList, page, pageSize } = this.emissionActivityListData;
    return fullList.slice((page - 1) * pageSize, page * pageSize);
  }

  ////////設定Emission Removal & Mitigation List data
  _handleSetRMActivityListData = (key, data) => {
    this.rmActivityListData[key] = data;
  };

  ////////計算Emission Removal & Mitigation目前頁面資料
  get RMCurrentPageList() {
    const { fullList, page, pageSize } = this.rmActivityListData;
    return fullList.slice((page - 1) * pageSize, page * pageSize);
  }

  ////////新增Emission Removal & Mitigation活動
  getRMActivityListData = async ({ keepPage = false } = {}) => {
    if (!EMISSION_REMOVAL_MITIGATION_ENABLED) return [];

    this._handleSetRMActivityListLoading(true);
    this._handleSetRMActivityListData("fullList", []);
    if (!keepPage) this._handleSetSharedListPage(1);

    try {
      const data = await service.fetchRemovalMitigationListData(
        this.authComArr,
        this.selectedYear,
        this.selectedEmissionGwpId,
      );

      if (data === null) return null;
      this._handleSetRMActivityListData("fullList", data);
      this._ensureSharedListPageInRange(this.rmActivityListData);
      return data;
    } catch (err) {
      console.error(err);
      this._handleSetRMActivityListData("fullList", []);
      return null;
    } finally {
      this._handleSetRMActivityListLoading(false);
    }
  };

  ////////刪除Emission Removal & Mitigation活動
  _handleDeleteRMActivity = (id) => {
    this.rmActivityListData.fullList = this.rmActivityListData.fullList.filter(
      (item) => item.id !== id,
    );
  };

  ////////設定emissionFactorListdata
  deleteRMActivityData = async (id) => {
    if (!EMISSION_REMOVAL_MITIGATION_ENABLED || !id) return null;

    try {
      const response = await service.deleteRemovalMitigation(id);
      if (response?.success === false) return null;

      await this.getRMActivityListData({ keepPage: true });
      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.GHG_PERFORMANCE_DELETE_SUCCESS,
      });
      return true;
    } catch (err) {
      console.error(err);
      handleAPIError(err, { throwError: false });
      return null;
    }
  };

  _handleSetEmissionFactorListData = (key, data) => {
    this.emissionFactorListData[key] = data;
  };

  ////////計算emissionFactorList的目前頁面資料
  get EFCurrentPageList() {
    const { fullList, page, pageSize } = this.emissionFactorListData;
    return fullList.slice((page - 1) * pageSize, page * pageSize);
  }

  ////////設定DataEntryListData
  _handleSetDataEntryListData = (key, data) => {
    this.dataEntryListData[key] = data;
  };

  _handleSetDataEntryListError = (errorCode) => {
    this.dataEntryListError = errorCode;
  };

  ////////計算DataEntryList的目前頁面資料
  get DECurrentPageList() {
    const { fullList, page, pageSize } = this.dataEntryListData;
    return fullList.slice((page - 1) * pageSize, page * pageSize);
  }

  ////////更新佐證資料
  _handleSetValidationFileListData = (update) => {
    if (typeof update === "function") {
      this.validationFileListData = update(this.validationFileListData);
    } else {
      this.validationFileListData = update;
    }
  };

  ////////設定EmissionListData
  _handleSetEmissionListData = (key, data) => {
    this.emissionListData[key] = data;
  };

  ////////計算EmissionList的目前頁面資料
  get EmissionCurrentPageList() {
    const { fullList, page, pageSize } = this.emissionListData;
    return fullList.slice((page - 1) * pageSize, page * pageSize);
  }

  ////////更新EmissionActivityExcelModal
  _handleSetIsShowEmissionActivityExcelModal = (value) => {
    this.isShowEmissionActivityExcelModal = value;
  };

  ////////更新DataEntryExcelModal
  _handleSetIsShowDataEntryExcelModal = (value) => {
    this.isShowDataEntryExcelModal = value;
  };

  /////////重新整理按鈕
  _handleRefresh = () => {
    this.isRefresh = !this.isRefresh;
  };

  ////////更新搜尋關鍵字
  _handleSetSearchKeyword = (word) => {
    const keywordChanged = this.searchKeyword !== word;
    this.searchKeyword = word;
    if (keywordChanged) this._handleSetSharedListPage(1);
  };

  ////////更新EmissionFactorExcelModal
  _handleSetIsShowEmissionFactorExcelModal = (value) => {
    this.isShowEmissionFactorExcelModal = value;
  };

  ////////更新searchLabel
  _handleSetSearchLabel = (value) => {
    this.searchLabel = value;
  };

  ////////更新EFIncertModal
  _handleSetIsShowEFIncertModal = (value) => {
    this.isShowEFIncertModal = value;
  };

  ////////更新emissionActiviytList唯一識別碼
  _handleSetActivityListUniqueId = () => {
    this.activityListUniqueId += 1;
  };

  ////////更新dataEntryList唯一識別碼
  _handleSetDataEntryListUniqueId = () => {
    this.dataEntryListUniqueId += 1;
  };

  ////////更新emissionFactorList唯一識別碼
  _handleSetEmissionFactorListUniqueId = () => {
    this.emissionFactorListUniqueId += 1;
  };

  ////////更新emissionList唯一識別碼
  _handleSetEmissionListUniqueId = () => {
    this.emissionListUniqueId += 1;
  };

  ////////更新authComArr
  _handleSetAuthComArr = (authCArr) => {
    const companiesChanged =
      this.authComArr.length !== authCArr.length ||
      this.authComArr.some((id, index) => id !== authCArr[index]);
    this.authComArr = authCArr;
    if (companiesChanged) this._handleSetSharedListPage(1);
    console.log("authComArr", JSON.stringify(this.authComArr));
  };

  // 只負責寫入
  _setVal = (data, level, key, value) => {
    const L = String(level);
    const arr = data[L] ?? [];
    const idx = arr.findIndex((o) => Object.hasOwn(o, key));

    const nextArr =
      idx >= 0
        ? arr.map((o, i) => (i === idx ? { ...o, [key]: value } : o))
        : [...arr, { [key]: value }];

    return { ...data, [L]: nextArr };
  };

  // 刪除欄位
  _delVal = (data, level, key) => {
    const L = String(level);
    const arr = data[L] ?? [];
    const nextArr = arr.filter((o) => !Object.hasOwn(o, key));
    return { ...data, [L]: nextArr };
  };

  // 清空低階層的 showIf 欄位
  _clearBelow = (data, schema, fromLevel) => {
    let next = data;
    (schema.fields || [])
      .filter(
        (f) =>
          f.level > fromLevel &&
          ("showIf" in f || f.cascadeClear) &&
          !f.constant,
      )
      .forEach((f) => {
        next = this._delVal(next, f.level, f.key);
      });
    return next;
  };

  // 清空其他 formData 的低階層
  _clearOtherFormBelow = (fromLevel, targets = ["EFFormData"]) => {
    console.log(targets);
    // 需要的 formData 清單

    targets.forEach((formKey) => {
      let next = this[formKey];
      if (!next) return;

      // 把大於 fromLevel 的 key 清掉
      Object.keys(next).forEach((lvl) => {
        if (+lvl > fromLevel) {
          delete next[lvl];
        }
      });

      // 回寫
      this[formKey] = { ...next };
    });
  };

  // 寫入 + 清空
  _handleSetEAFormData = (
    schema,
    level,
    key,
    value,
    optionMeta,
    target = "EAFormData",
  ) => {
    ////////如果有要哪一項不會被清空 讓那一項的數值靠前面
    let data = this[target];

    const prev = this.getEAValue(level, key, target);
    const changed = prev !== value;

    // 寫入
    data = this._setVal(data, level, key, value === "clear" ? null : value);

    // 只在需要 cascade 時才清空
    const fieldConf = schema.fields.find(
      (f) => f.key === key && f.level === level,
    );

    const forceCascadeByValue = value === "clear";

    const shouldCascade =
      changed &&
      ((fieldConf?.resetOnChange ?? true) || // 原本欄位等級的規則
        forceCascadeByValue); // ★ 值層級覆蓋：命中就清
    if (shouldCascade) data = this._clearBelow(data, schema, level);

    const RESET_ON_CHANGE_KEYS = {
      calculationId: true,
      activityId: true,
      isBiomassActivity: true,
      isBiomassSeparate: true,
      categoryISO64: true,
      ghgActivityNameId: true,
    };

    if (RESET_ON_CHANGE_KEYS[key] && changed && fieldConf?.resetOnChange) {
      this._clearOtherFormBelow(level);
    }

    if (key === "isTransport" && changed) {
      //////// 特殊處理 isTransport
      this._clearOtherFormBelow(level, ["EFLandFormData"]);
    }

    ////////特殊規則special key
    ////大眾運輸
    if (optionMeta && typeof optionMeta === "object") {
      if (optionMeta.isMassTransit) {
        data = this._setVal(data, 10, "isMassTransit", 1);
      } else {
        data = this._delVal(data, 10, "isMassTransit");
      }

      ////1_4逸散率
      if (optionMeta.fugitiveEmissions) {
        data = this._setVal(
          data,
          11,
          "fugitiveEmissions",
          optionMeta.fugitiveEmissions,
        );
      }
    }
    this[target] = data;
    console.log(`${target} :`, JSON.stringify(this[target]));
  };

  // 取值
  getEAValue = (level, key, target = "EAFormData") => {
    const arr = this[target]?.[String(level)] || [];
    const found = arr.find((o) => Object.hasOwn(o, key));
    return found ? found[key] : null;
  };

  ////////修改取單筆排放活動資料賦值
  _handleEditEAFormData = (data, target = "EAFormData") => {
    this[target] = data;
    console.log(target, ":", JSON.stringify(this[target]));
  };

  _handleReSetEAFormData = () => {
    this.EAFormData = {};
    this.landEAFormData = {};
  };

  //////// 改變 EF 資料
  _handleSetEFFormData = (
    schema,
    level,
    key,
    value,
    optionMeta,
    target = "EFFormData",
  ) => {
    let data = this[target];

    const prev = this.getEFValue(level, key, target);
    const changed = prev != value;

    data = this._setVal(data, level, key, value === "clear" ? null : value);

    const fieldConf = schema.fields.find(
      (f) => f.key === key && f.level === level,
    );

    const forceCascadeByValue = value === "clear";

    const shouldCascade =
      changed && ((fieldConf?.resetOnChange ?? true) || forceCascadeByValue);

    if (shouldCascade) data = this._clearBelow(data, schema, level);

    this[target] = data;
    console.log(`${target} :`, JSON.stringify(this[target]));
  };

  getEFValue = (level, key, target = "EFFormData") => {
    const arr = this[target]?.[String(level)] || [];
    const found = arr.find((o) => Object.hasOwn(o, key));
    return found ? found[key] : null;
  };

  //////// 修改單筆
  _handleEditEFFormData = (data, target = "EFFormData") => {
    this[target] = data;
    console.log(`${target} :`, JSON.stringify(this[target]));
  };

  //////// Reset
  _handleReSetEFFormData = (target = "EFFormData") => {
    this[target] = {};
  };

  ////////更新EFIncertFormData
  _handleSetEFIncertFormData = (clear = false, key, value) => {
    if (clear === true) this.EFIncertFormData = {};
    this.EFIncertFormData[key] = value;
    console.log(JSON.stringify(this.EFIncertFormData));
  };

  ////////更改EFCheckId
  _handleSetEFCheckId = (id) => {
    this.EFCheckId = id;
    console.log(this.EFCheckId);
  };

  ////////更改landEFCheckId
  _handleSetLandEFCheckId = (con) => {
    this.landEFCheckId = con;
  };

  ////////更改顯示新增自定義EF表單
  _handleSwitchShowAddCustomEFModal = () => {
    this.showAddCustomEFModal = !this.showAddCustomEFModal;
  };

  //////// 更改目前的查驗版本
  _handleSetStandard = (standardId) => {
    this.standardId = standardId;
    this.selectedScope = getConstByStandard(
      this.standardId,
    ).categoryDropdown[0].label;
    this._handleSetSharedListPage(1);
  };

  //////// 取得排放活動列表
  getEAListData = async ({ keepPage = false } = {}) => {
    let unitId = this.activityListUniqueId + 1;
    this._handleSetActivityListUniqueId();
    this._handleSetEmissionActivityListLoading(true);
    this._handleSetEmissionActivityListData("fullList", []);
    if (!keepPage) this._handleSetSharedListPage(1);

    try {
      const data = await service.fetchEAListData(
        this.authComArr,
        this.selectedYear,
        this.searchKeyword,
        this.selectedTab,
        this.selectedScope,
        this.standardId,
      );

      if (unitId === this.activityListUniqueId) {
        this._handleSetEmissionActivityListData(
          "fullList",
          Array.isArray(data) ? data : [],
        );
        this._ensureSharedListPageInRange(this.emissionActivityListData);
      }
    } catch (err) {
      console.error(err);
      return null;
    } finally {
      if (unitId === this.activityListUniqueId) {
        this._handleSetEmissionActivityListLoading(false);
      }
    }
  };

  //////// 新增排放活動
  addEA = async () => {
    const schema = getEASchemaByStandard(this.standardId)[this.selectedTab];
    this._handleSetEmissionActivityModalLoading(true);

    try {
      const response = await service.addEA(
        this.selectedYear,
        this.EAFormData,
        this.EFFormData,
        this.EFLandFormData,
        this.landEAFormData,
        schema,
        this.selectedTab,
        this.standardId,
      );

      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_ACTIVITY_CREATE_SUCCESS,
      });

      this._handleSetCloseEmissionActivityModal();
      this._handleReSetEAFormData();
      this._handleReSetEFFormData();
      this._handleReSetEFFormData("EFLandFormData");
      this._handleReSetEFFormData("EFSeaFormData");
      this._handleReSetEFFormData("EFAirFormData");

      await this.getEAListData();
    } catch (err) {
      console.error(err);
      handleAPIError(err, { throwError: false });
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  //////// 修改排放活動
  editEA = async () => {
    if (this.EFCheckId) {
      this._handleSetIsShowDataEntryUnitMismatchModal(true);
      return;
    }

    this._handleSetEmissionActivityModalLoading(true);

    try {
      const response = await service.editEA(
        this.EAFormData,
        this.landEAFormData,
        this.EFFormData,
        this.EFLandFormData,
        this.EFSeaFormData,
        this.EFAirFormData,
        this.selectedTab,
      );

      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_ACTIVITY_UPDATE_SUCCESS,
      });

      this._handleSetEFCheckId("");
      this._handleSetCloseEmissionActivityModal();
      this._handleReSetEAFormData();
      this._handleReSetEFFormData();
      this._handleReSetEFFormData("EFLandFormData");
      this._handleReSetEFFormData("EFSeaFormData");
      this._handleReSetEFFormData("EFAirFormData");

      await this.getEAListData({ keepPage: true });
    } catch (err) {
      console.error(err);
      handleAPIError(err, { throwError: false });
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  //////// 取得單筆排放活動
  getSingleEAData = async (id, categoryISO64) => {
    try {
      const data = await service.fetchSingleEAData(
        this.selectedTab,
        id,
        categoryISO64,
      );
      return data;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  //////// 刪除排放活動
  deleteEAData = async (id) => {
    try {
      const response = await service.deleteEA(this.selectedTab, id);
      if (response?.success === false) {
        handleAPIError(null, { apiData: response, throwError: false });
        return null;
      }

      showSuccessToast({
        apiData: response,
        scenarioCode:
          MESSAGE_CODES.EMISSION_INVENTORY_ACTIVITY_DELETE_SUCCESS,
      });
      return true;
    } catch (err) {
      console.error(err);
      handleAPIError(err, { throwError: false });
      return null;
    }
  };

  //////// 下載排放活動Excel
  downloadEAExcel = async (lang) => {
    this._handleSetEmissionActivityModalLoading(true);
    try {
      const response = await service.downloadEAExcel(
        this.authComArr,
        lang,
        this.selectedYear,
        this.selectedTab,
        this.standardId,
      );
      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_EXPORT_SUCCESS,
      });
      return response;
    } catch (err) {
      console.error(err);
      handleAPIError(err, { throwError: false });
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  //////// 上傳排放活動Excel
  uploadEAExcel = async (type, lang, file) => {
    this._handleSetEmissionActivityModalLoading(true);
    try {
      const data = await service.uploadEAExcel(
        type,
        this.authComArr,
        this.selectedYear,
        lang,
        this.selectedTab,
        this.standardId,
        file,
      );

      if (data.success) {
        this._handleSetIsShowEmissionActivityExcelModal(false);
        showSuccessToast({
          apiData: data,
          scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_IMPORT_COMPLETE,
        });
        this.getEAListData();
      }
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  ////////////////大量上傳excel
  bulkUploadEAExcel = async (type, lang, file) => {
    // this._handleSetEmissionActivityModalLoading(true);
    try {
      const data = await service.bulkUploadEAExcel(
        type,
        this.authComArr,
        this.selectedYear,
        lang,
        this.selectedTab,
        this.standardId,
        file,
      );

      if (data.success) {
        return data.data?.jobId || data.jobId;
      }
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return null;
    }
  };

  //////// 取得數據輸入列表
  getDEListData = async ({ keepPage = false } = {}) => {
    let unitId = this.dataEntryListUniqueId + 1;
    this._handleSetDataEntryListUniqueId();
    this._handleSetDataEntryListLoading(true);
    this._handleSetDataEntryListData("fullList", []);
    this._handleSetDataEntryListError(null);
    if (!keepPage) this._handleSetSharedListPage(1);
    try {
      const data = await service.fetchDEListData(
        this.authComArr,
        this.selectedYear,
        this.searchKeyword,
        this.selectedTab,
        this.selectedScope,
        this.standardId,
      );

      console.log(JSON.stringify(data));

      if (unitId === this.dataEntryListUniqueId) {
        this._handleSetDataEntryListData(
          "fullList",
          Array.isArray(data) ? data : [],
        );
        this._ensureSharedListPageInRange(this.dataEntryListData);
      }
    } catch (err) {
      console.error(err);
      if (unitId === this.dataEntryListUniqueId) {
        this._handleSetDataEntryListError(
          err?.response?.data?.error_code ?? null,
        );
      }
      return null;
    } finally {
      if (unitId === this.dataEntryListUniqueId) {
        this._handleSetDataEntryListLoading(false);
      }
    }
  };

  /////////設定數據輸入
  setDE = async (format, unit, { showSuccess = true } = {}) => {
    this._handleSetDataEntryListLoading(true);
    try {
      const response = await service.setDE(
        this.selectedDataEntry.id,
        this.selectedTab,
        format,
        unit,
      );
      if (response?.success === false) {
        handleAPIError(null, { apiData: response, throwError: false });
        return null;
      }
      if (showSuccess) {
        showSuccessToast({
          apiData: response,
          scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_DATA_UPDATE_SUCCESS,
        });
      }
      return true; // 表示成功
    } catch (error) {
      console.error("Error data setting", error);
      handleAPIError(error, { throwError: false });
      return null;
    } finally {
      this._handleSetDataEntryListLoading(false);
    }
  };

  //////////// 新增數據輸入
  addDE = async (
    dataFormat,
    usedDate,
    confirmedRange,
    consumptionValue,
    catFields,
    isCat3x,
    isCat3basic,
  ) => {
    this._handleSetDataEntryListLoading(true);
    try {
      const response = await service.addDE(
        dataFormat,
        usedDate,
        confirmedRange,
        consumptionValue,
        catFields,
        isCat3x,
        isCat3basic,
        this.selectedDataEntry.calculationId,
        this.selectedTab,
        this.selectedDataEntry.companyId,
        this.selectedDataEntry.id,
        this.selectedYear,
      );
      if (response?.success === false) {
        handleAPIError(null, { apiData: response, throwError: false });
        return null;
      }

      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_DATA_CREATE_SUCCESS,
      });
      return true; // 表示成功
    } catch (error) {
      console.error("Error data setting", error);
      handleAPIError(error, { throwError: false });
      return null;
    } finally {
      this._handleSetDataEntryListLoading(false);
    }
  };

  //////// 修改數據輸入
  editDE = async (
    usedDate,
    confirmedRange,
    consumptionValue,
    catFields,
    isCat3x,
    isCat3basic
  ) => {
    this._handleSetDataEntryListLoading(true);
    try {
      const response = await service.editDE(
        this.selectedDataEntry.dataTypeId,
        usedDate,
        confirmedRange,
        consumptionValue,
        catFields,
        isCat3x,
        isCat3basic,
        this.selectedDataEntry.calculationId,
        this.selectedTab,
        this.selectedDataEntry.companyId,
        this.selectedYear,
        this.selectedDataEntryItem.id,
      );
      if (response?.success === false) {
        handleAPIError(null, { apiData: response, throwError: false });
        return null;
      }

      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_DATA_UPDATE_SUCCESS,
      });
      return true; // 表示成功
    } catch (error) {
      console.error("Error data setting", error);
      handleAPIError(error, { throwError: false });
      return null;
    } finally {
      this._handleSetDataEntryListLoading(false);
    }
  };

  //////// 下載數據輸入Excel
  downloadDEExcel = async (lang, rootId, isAll = false, isSummary = false) => {
    this._handleSetEmissionActivityModalLoading(true);
    try {
      const response = await service.downloadDEExcel(
        this.authComArr,
        lang,
        this.selectedYear,
        this.selectedTab,
        rootId,
        this.standardId,
        isAll,
        isSummary,
      );
      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_EXPORT_SUCCESS,
      });
      return response;
    } catch (err) {
      console.error(err);
      const message = err.response?.data?.message;
      if (message) showErrorToast({ fallback: message });
      else handleAPIError(err, { throwError: false });
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  //////// 上傳數據輸入Excel
  uploadDEExcel = async (file, lang) => {
    this._handleSetEmissionActivityModalLoading(true);
    try {
      const data = await service.uploadDEExcel(
        this.authComArr,
        this.selectedYear,
        file,
        this.selectedTab,
        lang,
        this.standardId,
      );

      if (data?.success) {
        this._handleSetIsShowDataEntryExcelModal(false);
        showSuccessToast({
          apiData: data,
          scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_DATA_UPLOAD_SUCCESS,
        });
        this.getDEListData();
      }
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  //////// 大量上傳數據輸入Excel
  bulkUploadDEExcel = async (type, file, lang) => {
    try {
      const data = await service.bulkUploadDEExcel(
        type,
        this.authComArr,
        this.selectedYear,
        file,
        this.selectedTab,
        lang,
        this.standardId,
      );

      if (data.success) {
        return data.data?.jobId || data.jobId;
      }
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return null;
    }
  };

  ///刪除數據輸入
  deleteDE = async (dataEntryItemId) => {
    try {
      const response = await service.deleteDE(
        this.selectedTab,
        this.selectedDataEntryCompanyId,
        dataEntryItemId,
      );
      if (response?.success === false) {
        handleAPIError(null, { apiData: response, throwError: false });
        return null;
      }

      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_DATA_DELETE_SUCCESS,
      });
      return true;
    } catch (err) {
      console.error(err);
      handleAPIError(err, { throwError: false });
      return null;
    }
  };

  //////// 取得排放係數列表
  getEFListData = async ({ keepPage = false } = {}) => {
    const isBiomass =
      this.selectedScope === "CO₂ Emission From Biomass/Bioenergy";

    let unitId = this.activityListUniqueId + 1;
    this._handleSetActivityListUniqueId();
    this._handleSetEmissionActivityListLoading(true);
    this._handleSetEmissionFactorListData("fullList", []);
    if (!keepPage) this._handleSetSharedListPage(1);
    try {
      const data = await service.fetchEFListData(
        this.authComArr,
        this.selectedYear,
        this.searchKeyword,
        isBiomass,
        this.selectedTab,
        this.standardId,
      );

      console.log(JSON.stringify(data));

      if (unitId === this.activityListUniqueId) {
        this._handleSetEmissionFactorListData(
          "fullList",
          Array.isArray(data) ? data : [],
        );
        this._ensureSharedListPageInRange(this.emissionFactorListData);
      }
    } catch (err) {
      console.error(err);
      return null;
    } finally {
      if (unitId === this.activityListUniqueId) {
        this._handleSetEmissionActivityListLoading(false);
      }
    }
  };

  //////// 取得 1.4 未套用搜尋條件的自定義 EF 數量
  getCustomEFCount = async () => {
    const requestId = this.customEFCountRequestId + 1;
    this.customEFCountRequestId = requestId;
    this.customEFCount = null;
    this.customEFCountStatus = "loading";

    try {
      const data = await service.fetchEFListData(
        this.authComArr,
        this.selectedYear,
        "",
        false,
        this.selectedTab,
        this.standardId,
      );

      if (requestId !== this.customEFCountRequestId) return null;
      if (!Array.isArray(data)) {
        throw new Error("Invalid emission factor list response");
      }

      this.customEFCount = data.filter(
        (item) =>
          item?.sourceEFId === null &&
          item?.sourceEFName === "Custom Emission Factor",
      ).length;
      this.customEFCountStatus = "success";
      return this.customEFCount;
    } catch (err) {
      if (requestId !== this.customEFCountRequestId) return null;
      console.error("Failed to fetch custom EF count", err);
      this.customEFCount = null;
      this.customEFCountStatus = "error";
      return null;
    }
  };

  //////// 取得單筆排放係數
  getSingleEFData = async (id) => {
    try {
      const data = await service.fetchSingleEFData(this.selectedTab, id);
      return data;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  //////// 取得排放係數下拉式選單資料
  getEFDropdownData = async (catName, paramValue, flatEA) => {
    try {
      const data = await service.fetchEFLevelDropdown(
        this.selectedTab,
        catName,
        paramValue,
        flatEA,
      );

      return data;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  //////// 修改排放係數
  editEF = async () => {
    if (this.EFCheckId) {
      this._handleSetIsShowDataEntryUnitMismatchModal(true);
      return;
    }

    this._handleSetEmissionActivityModalLoading(true);
    try {
      const response = await service.editEF(
        this.EFFormData,
        this.EAFormData,
        this.EFLandFormData,
        this.selectedTab,
      );

      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_EF_UPDATE_SUCCESS,
      });

      await this.getEFListData({ keepPage: true });

      this._handleCloseEmissionFactorEditModal();

      this._handleReSetEFFormData("EFLandFormData");
      this._handleReSetEFFormData("EFSeaFormData");
      this._handleReSetEFFormData("EFAirFormData");
    } catch (error) {
      console.error(error);
      handleAPIError(error, { throwError: false });
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  //////// 下載排放係數Excel
  downloadEFExcel = async (lang, isAll) => {
    this._handleSetEmissionActivityModalLoading(true);
    try {
      const response = await service.downloadEFExcel(
        this.authComArr,
        this.selectedYear,
        this.selectedTab,
        this.standardId,
        lang,
        isAll,
      );
      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_EXPORT_SUCCESS,
      });
      return response;
    } catch (err) {
      console.error(err);
      handleAPIError(err, { throwError: false });
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  //////// 上傳排放係數Excel
  uploadEFExcel = async (file) => {
    this._handleSetEmissionActivityModalLoading(true);
    try {
      const data = await service.uploadEFExcel(
        file,
        this.selectedTab,
        this.standardId,
      );

      if (data?.success) {
        this._handleSetEmissionActivityModalLoading(false);
        showSuccessToast({
          apiData: data,
          scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_IMPORT_COMPLETE,
        });
        this.getEFListData();
      }
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return null;
    } finally {
      this._handleSetEmissionActivityModalLoading(false);
    }
  };

  ///////大量上傳排放係數excel
  bulkUploadEFExcel = async (type, file) => {
    try {
      const data = await service.bulkUploadEFExcel(
        type,
        file,
        this.selectedTab,
        this.standardId,
      );

      if (data.success) {
        return data.data?.jobId || data.jobId;
      }
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return null;
    }
  };

  //////// 取得排放當量列表
  getEMListData = async ({ keepPage = false } = {}) => {
    let unitId = this.emissionListUniqueId + 1;
    this._handleSetEmissionListUniqueId();
    this._handleSetEmissionListLoading(true);
    this._handleSetEmissionListData("fullList", []);
    if (!keepPage) this._handleSetSharedListPage(1);
    try {
      const data = await service.fetchEMListData(
        this.authComArr,
        this.selectedYear,
        this.searchKeyword,
        this.selectedTab,
        this.selectedScope,
        this.standardId,
        this.selectedEmissionUnitId,
        this.selectedEmissionGwpId,
      );

      console.log(JSON.stringify(data));

      if (unitId === this.emissionListUniqueId) {
        this._handleSetEmissionListData(
          "fullList",
          Array.isArray(data) ? data : [],
        );
        this._ensureSharedListPageInRange(this.emissionListData);
      }
    } catch (err) {
      console.error(err);
      return null;
    } finally {
      if (unitId === this.emissionListUniqueId) {
        this._handleSetEmissionListLoading(false);
      }
    }
  };

  //////// 重新計算排放當量（Emission 頁面 Refresh 用）
  // 步驟一：POST 建立任務取得 taskId
  // 步驟二：輪詢 status 直到 succeeded
  // 步驟三：呼叫 getEMListData() 更新畫面
  recalculateEmission = async (rootId) => {
    try {
      const result = await service.recalculate(rootId, this.selectedYear);
      const taskId = result?.data?.task_id;
      if (!taskId) throw new Error("No taskId returned from recalculate API");

      const completionResponse = await this._pollRecalculateStatus(taskId);
      await this.getEMListData();
      showSuccessToast({
        apiData: completionResponse,
        scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_REFRESH_SUCCESS,
      });
      return true;
    } catch (err) {
      console.error("Emission recalculate failed:", err);
      handleAPIError(err, { throwError: false });
      return null;
    }
  };

  // 輪詢 status API，每 3 秒查一次，最多 30 次
  _pollRecalculateStatus = (taskId, interval = 3000, maxAttempts = 30) => {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const poll = async () => {
        if (attempts >= maxAttempts) {
          reject(new Error("Recalculate polling timeout"));
          return;
        }
        attempts += 1;
        try {
          const result = await service.getRecalculateStatus(taskId);
          const status = result?.data?.status;
          if (status === "succeeded") {
            resolve(result);
          } else if (status === "failed") {
            const error = new Error("Recalculation task failed");
            error.response = { data: result };
            reject(error);
          } else {
            // pending / running 等過渡狀態，繼續等待
            setTimeout(poll, interval);
          }
        } catch (err) {
          reject(err);
        }
      };
      poll();
    });
  };

  //////// 新增 setUnit Store Action
  setUnit = async (scope, id, unit) => {
    console.log(scope, id, unit);
    try {
      const result = await service.setUnit(scope, id, unit);
      if (result?.success) {
        await this.getDEListData();
        showSuccessToast({
          apiData: result,
          scenarioCode: MESSAGE_CODES.EMISSION_INVENTORY_DATA_UPDATE_SUCCESS,
        });
        return true;
      }
      return false;
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return false;
    }
  };
}
const emissionViewStore = new EmissionViewStore();
export default emissionViewStore;
